<template>
  <transition appear name="slide">
    <div class="legal-notice-container">
      <div class="notice-message" v-html="legalNotice" />
      <button class="close-icon" type="button" @click="closeToast"></button>
    </div>
  </transition>
</template>

<script>
import { setCookie } from '@/modules/services/cookies'

export default {
  name: 'LegalNotice',

  props: {
    legalNotice: {
      type: String,
      default: ''
    }
  },

  methods: {
    closeToast () {
      // set 10 years expiry time
      const expiryTime = 3650 * 24 * 60 * 60
      setCookie('legal_notice', true, expiryTime, '/')
      this.$emit('close-toast')
    }
  }
}
</script>

<style lang="scss" scoped>
.legal-notice-container {
  width: 100%;
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000000; // added this value to show it above the Zendesk chat widget as they were overlapping.
  background: $grey-light;
  display: flex;
  justify-content: center;
  align-items: center;
}

.notice-message {
  padding: 21px;
  text-align: center;

  @include media-breakpoint-down(sm) {
    text-align: left;
  }
}

.close-icon {
  position: absolute;
  top: 8px;
  right: 10px;
  cursor: pointer;
  width: 14px;
  height: 14px;
  border: none;
  background: transparent url('../../assets/images/icons/close-black.svg') no-repeat center;
}

.slide-leave-active,
.slide-enter-active {
  transition: 1s ease;
}

.slide-enter,
.slide-leave-to {
  transform: translate(0, 100%);
}
</style>
